import { type FC } from "react";
import * as styles from "./styles.css";

const Employment = {
  regularMember: "正",
  arbeit: "ア",
  businessConsignment: "業",
  contractEmployee: "契",
  other: "他",
} as const;

type EmploymentType = keyof typeof Employment;

type Props = {
  employments: EmploymentType[];
  site: "biyo" | "kaigo";
};

export const EmploymentLabels: FC<Props> = ({ employments, site }) => {
  const employmentKeys: EmploymentType[] = Object.keys(Employment) as EmploymentType[];
  return (
    <ul className={styles.list}>
      {employmentKeys.map((key) => (
        <li
          className={
            employments.includes(key) ? styles.item[site].active : styles.item[site].inactive
          }
          key={key}
        >
          {Employment[key]}
        </li>
      ))}
    </ul>
  );
};
